// 测速结果页分享配置，文档见：http://wiki.wx.xunlei.cn/pages/viewpage.action?pageId=99027504
// import { getHost } from "@/utils/utils";
const SHARE_IMG = `https://speedtest.onethingpcs.com/share.png?20210304`;
export function setShareConfig(data) {
  const SHAER_CONFIG = {
    share_config: {
      list: [
        {
          platform: 0,
          type: 1,
          share_link: data.share_link,
          share_content: "一个能测5G网速的测速app，快下载试试吧！",
          share_title: `我的网速只超过了${data.percent}的用户，你的呢？`,
          share_image: SHARE_IMG,
        },
        {
          platform: 1,
          type: 1,
          share_link: data.share_link,
          share_content: "一个能测5G网速的测速app，快下载试试吧！",
          share_title: `我的网速只超过了${data.percent}的用户，你的呢？`,
          share_image: SHARE_IMG,
        },
        {
          platform: 5,
          type: 1,
          share_link: `我的网速只超过了${data.percent}的用户，你的呢？一个能测5G网速的测速app，快下载试试吧！${data.share_link}`,
          share_content: `我的网速只超过了${data.percent}的用户，你的呢？一个能测5G网速的测速app，快下载试试吧！${data.share_link}`,
          share_title: `我的网速只超过了${data.percent}的用户，你的呢？`,
          share_image: SHARE_IMG,
        },
      ],
    },
  };
  return SHAER_CONFIG;
}
